import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTitleBuilder } from 'components/views/titleBuilder';
import AddTitleAttachment from 'components/common/AddTitleAttachment';
import ButtonMenu from 'components/common/ButtonMenu';
import ErrorBoundary from 'components/common/ErrorBoundary';
import StyledScrollbar from 'components/common/StyledScrollbar';
import TitleItemImport from 'components/common/TitleItemImport';
import Item from './Item';
import Form from './Form';
import { sortSlides } from './utils';
import itemFormDefaults from './itemFormDefaults';

const TimelineBuilder = ({ formsetData, hasError, parentId }) => {
  const opts = {
    formsetData,
    itemLabel: 'slide',
    itemLabelPlural: 'slides',
    hasError,
    isSortable: false,
    ItemComponent: Item,
    itemFormDefaults,
  };

  const {
    itemsById,
    setItemsOrdered,
    activeItem,
    handleItemAdd,
    initNewItems,
    handleFormChange,
    managementForm,
    messages,
    renderEmptyMessage,
    renderedItems,
  } = useTitleBuilder(opts);

  useEffect(() => updateSortOrder(), [itemsById]);

  const updateSortOrder = () => {
    const newItemsOrdered = sortSlides(itemsById);
    setItemsOrdered(newItemsOrdered);
  };

  const [importSource, setImportSource] = useState(null);
  const handleImport = items => {
    initNewItems(items);
    setImportSource(null);
  };

  return (
    <div className="title-builder object-detail-panel-full-height">
      <ErrorBoundary>
        {managementForm}
        <div className="title-builder-items-container">
          <StyledScrollbar>
            {messages}
            <div className="title-builder-item disabled" style={{ justifyContent: 'flex-end' }}>
              <AddTitleAttachment
                modalTitleText="Select import source"
                preFilter={{ type: 'Timeline' }}
                disabledFilters={['type']}
                onChange={setImportSource}
              >
                {handleModalTrigger => (
                  <ButtonMenu
                    label="Add New Slides"
                    items={[
                      { label: 'Import Slides', iconName: 'input', onClick: handleModalTrigger },
                      { label: 'Add Blank Slide', iconName: 'view_timeline', onClick: handleItemAdd },
                    ]}
                  />
                )}
              </AddTitleAttachment>
            </div>
            {renderedItems}
          </StyledScrollbar>
        </div>

        {activeItem ? (
          <Form
            item={activeItem}
            key={activeItem.itemId}
            onChange={handleFormChange}
          />
        ) : renderEmptyMessage()}

        {!!importSource && (
          <TitleItemImport
            sourceId={importSource}
            targetId={parentId}
            formsetName="slides"
            itemComponent={Item}
            onAccept={handleImport}
            onCancel={() => setImportSource(null)}
          />
        )}
      </ErrorBoundary>
    </div>
  );
};

TimelineBuilder.propTypes = {
  formsetData: PropTypes.object,
  parentId: PropTypes.string,
  hasError: PropTypes.bool,
};

export default TimelineBuilder;
